(function(undefined) {
    var window = this || (0, eval)('this'),
        document = window['document'],
        navigator = window['navigator'],
        jQuery = window["jQuery"],
        JSON = window["JSON"];

    (function(factory) {
        if (typeof define === 'function' && define['amd']) {
            define(['exports', 'require'], factory);
        } else if (typeof exports === 'object' && typeof module === 'object') {
            factory(module['exports'] || exports);
        } else {
            factory(window['atlas'] = {});
        }
    }(function(atlasExports, amdRequire) {
        var atlas = typeof atlasExports !== 'undefined' ? atlasExports : {};
        var internals = {}

var BrandingModel,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

BrandingModel = (function() {
  function BrandingModel() {
    this.update = bind(this.update, this);
    var config;
    config = internals.getConfig();
    this.controlLogoutUrl = ko.observable(this.controlUrl + "/auth/logout");
    this.controlUrl = ko.observable(config.controlBaseUrl);
    this.portalLogoUrl = ko.observable((this.controlUrl()) + "/theme/logo/" + config.rootAccountAlias);
    this.mobileIconUrl = ko.observable((this.controlUrl()) + "/theme/MobileIcon/" + config.rootAccountAlias);
    this.favIconUrl = ko.observable((this.controlUrl()) + "/theme/favicon/" + config.rootAccountAlias);
    this.cssUrl = ko.observable((this.controlUrl()) + "/theme/SatelliteCSS/" + config.rootAccountAlias);
    this.controlName = ko.observable('...');
    this.headerBackgroundColor = ko.observable('#00853f');
    this.controlUserProfileUrl = ko.observable("");
  }

  BrandingModel.prototype.update = function(apiModel) {
    this.controlUrl(apiModel.controlUrl);
    if (apiModel.controlLogoutUrl) {
      this.controlLogoutUrl(apiModel.controlUrl + apiModel.controlLogoutUrl);
    } else {
      this.controlLogoutUrl(null);
    }
    this.cssUrl(apiModel.controlUrl + apiModel.satelliteCSSUrl);
    this.portalLogoUrl(apiModel.controlUrl + apiModel.portalLogoUrl);
    this.mobileIconUrl(apiModel.controlUrl + apiModel.mobileIconUrl);
    this.favIconUrl(apiModel.controlUrl + apiModel.faviconUrl);
    this.controlName(apiModel.controlName);
    this.controlUrl(apiModel.controlUrl);
    this.headerBackgroundColor(apiModel.headerBackgroundColor);
    if (apiModel.controlUserProfileUrl) {
      return this.controlUserProfileUrl(apiModel.controlUrl + apiModel.controlUserProfileUrl);
    } else {
      return this.controlUserProfileUrl(null);
    }
  };

  return BrandingModel;

})();

var SupportModel,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

SupportModel = (function() {
  function SupportModel() {
    this.update = bind(this.update, this);
    this.chatServiceUrl = ko.observable();
    this.supportEmail = ko.observable();
    this.supportPhone = ko.observable();
    this.supportRequestUrl = ko.observable();
    this.featureRequestUrl = ko.observable();
    this.knowledgeBaseUrl = ko.observable();
    this.knowledgeBaseSearchUrl = ko.observable();
  }

  SupportModel.prototype.update = function(apiModel) {
    this.chatServiceUrl(apiModel.chatServiceUrl);
    this.supportEmail(apiModel.supportEmail);
    this.supportPhone(apiModel.supportPhone);
    this.supportRequestUrl(apiModel.supportRequestUrl);
    this.featureRequestUrl(apiModel.featureRequestUrl);
    this.knowledgeBaseUrl(apiModel.knowledgebaseUrl);
    return this.knowledgeBaseSearchUrl(apiModel.knowledgebaseSearchUrl);
  };

  return SupportModel;

})();

var AccountSwitcherViewModel;

AccountSwitcherViewModel = (function() {
  function AccountSwitcherViewModel() {
    this.loadingAccounts = ko.observable(true);
    this.failedLoadingAccounts = ko.observable(false);
    this.accounts = ko.observableArray([]);
    this.currentAccountAlias = ko.observable('');
  }

  return AccountSwitcherViewModel;

})();

atlas.ajax = function(urlOrOptions, options) {
  var config, jqxhr, v2UrlPattern;
  v2UrlPattern = /^https:\/\/api\.(qa.|dev.)?ctl.io\//i;
  config = internals.getConfig();
  if (typeof urlOrOptions === 'object') {
    options = urlOrOptions;
  } else {
    options = options || {};
    options.url = urlOrOptions;
  }
  options.type = (options.type || 'GET').toUpperCase();
  if (options.data) {
    if (options.type !== 'GET' && options.type !== 'OPTIONS' && options.type !== 'HEAD') {
      options.contentType = options.contentType || 'application/json';
    }
    if (options.contentType === 'application/json' && typeof options.data !== 'string') {
      options.data = JSON.stringify(options.data);
    }
  }
  if (options.url && options.url.match(v2UrlPattern)) {
    options.headers = options.headers || {};
    options.headers['Authorization'] = options.headers['Authorization'] || ("Bearer " + config.bearerToken);
  }
  jqxhr = jQuery.ajax(options);
  return jQuery.extend(jqxhr, {
    aborted: function(func) {
      if (func) {
        this.fail((function(_this) {
          return function(xhr, textStatus, textReason) {
            if (!xhr.getAllResponseHeaders()) {
              return func(xhr, textStatus, textReason);
            }
          };
        })(this));
      }
      return this;
    },
    failed: function(func) {
      if (func) {
        this.fail((function(_this) {
          return function(xhr, textStatus, textReason) {
            if (xhr.getAllResponseHeaders()) {
              return func(xhr, textStatus, textReason);
            }
          };
        })(this));
      }
      return this;
    }
  });
};

var BrandBarViewModel;

BrandBarViewModel = (function() {
  function BrandBarViewModel(options, element) {
    options = $.extend({
      branding: {},
      support: {}
    }, options);
    if (!options.branding.controlUrl) {
      throw 'please supply controlUrl';
    }
    this.controlUrl = options.branding.controlUrl;
    if (!options.branding.controlLogoutUrl) {
      throw 'please supply controlLogoutUrl';
    }
    this.controlLogoutUrl = options.branding.controlLogoutUrl;
    if (!options.branding.portalLogoUrl) {
      throw 'please supply portalLogoUrl';
    }
    this.logoUrl = options.branding.portalLogoUrl;
    if (!options.branding.controlName) {
      throw 'please supply controlName';
    }
    this.controlName = options.branding.controlName;
    if (!options.support.chatServiceUrl) {
      throw 'please supply chatServiceUrl';
    }
    this.chatServiceUrl = options.support.chatServiceUrl;
    if (!options.support.supportEmail) {
      throw 'please supply supportEmail';
    }
    this.supportEmail = options.support.supportEmail;
    if (!options.support.supportPhone) {
      throw 'please supply supportPhone';
    }
    this.supportPhone = options.support.supportPhone;
    if (!options.support.supportRequestUrl) {
      throw 'please supply supportRequestUrl';
    }
    this.supportRequestUrl = options.support.supportRequestUrl;
    if (!options.support.featureRequestUrl) {
      throw 'please supply featureRequestUrl';
    }
    this.featureRequestUrl = options.support.featureRequestUrl;
    if (!options.support.knowledgeBaseUrl) {
      throw 'please supply knowledgeBaseUrl';
    }
    this.knowledgeBaseUrl = options.support.knowledgeBaseUrl;
    if (!options.support.knowledgeBaseSearchUrl) {
      throw 'please supply knowledgeBaseSearchUrl';
    }
    this.knowledgeBaseSearchUrl = options.support.knowledgeBaseSearchUrl;
    this.phoneLink = ko.pureComputed((function(_this) {
      return function() {
        return 'tel:' + ko.unwrap(_this.supportPhone).replace(/\./g, '');
      };
    })(this));
    this.shouldShowSupport = ko.pureComputed((function(_this) {
      return function() {
        return !!ko.unwrap(_this.chatServiceUrl) || !!ko.unwrap(_this.supportEmail) || !!ko.unwrap(_this.supportPhone) || !!ko.unwrap(_this.supportRequestUrl) || !!ko.unwrap(_this.featureRequestUrl) || !!ko.unwrap(_this.knowledgeBaseUrl) || !!ko.unwrap(_this.knowledgeBaseSearchUrl);
      };
    })(this));
    this.userName = options.userName;
    if (!options.branding.controlUserProfileUrl) {
      throw 'please supply controlUserProfileUrl';
    }
    this.profileLink = options.branding.controlUserProfileUrl;
    this.shouldShowUserInfo = ko.pureComputed((function(_this) {
      return function() {
        return !!ko.unwrap(_this.controlLogoutUrl) && !!ko.unwrap(_this.profileLink);
      };
    })(this));
    if (!options.searchUrl) {
      throw 'please supply a searchUrl';
    }
    this.searchUrl = options.searchUrl;
    this.logoutHandler = (function(_this) {
      return function() {
        var control, result, val;
        val = ko.unwrap(options.localLogout);
        control = ko.unwrap(_this.controlLogoutUrl);
        if (val) {
          if (typeof val === 'string') {
            return atlas.ajax({
              type: 'GET',
              url: val
            }).done(function() {
              return window.location.href = control;
            }).fail(function() {
              return console.warn('unable to signout of the local applicaiton');
            });
          } else if (typeof val === 'function') {
            result = val();
            if (result && result.then) {
              return result.then(function() {
                return window.location.href = control;
              });
            } else {
              return window.location.href = control;
            }
          }
        } else {
          return window.location.href = control;
        }
      };
    })(this);
  }

  return BrandBarViewModel;

})();

ko.components.register('brand-bar', {
  viewModel: {
    createViewModel: function(params, componentInfo) {
      return new BrandBarViewModel(params, componentInfo.element);
    }
  },
  template: {
    element: "atlas.brandBar"
  }
});

internals.getConfig = function() {
  if (!internals._config) {
    throw '`atlas.config` has not yet been called.';
  }
  return internals._config;
};

atlas.config = function(options) {
  if (options) {
    options = $.extend({
      mainNavId: ''
    }, options);
    if (!options.bearerToken) {
      throw 'bearerToken must be set';
    }
    if (!options.rootAccountAlias) {
      throw 'rootAccountAlias must be set';
    }
    if (!options.userName) {
      throw 'userName must be set';
    }
    if (!options.apiBaseUrl) {
      throw 'apiBaseUrl must be set';
    }
    if (!options.controlBaseUrl) {
      throw 'controlBaseUrl must be set';
    }
    internals._config = {
      bearerToken: options.bearerToken,
      rootAccountAlias: options.rootAccountAlias,
      userName: options.userName,
      apiBaseUrl: options.apiBaseUrl,
      controlBaseUrl: options.controlBaseUrl,
      mainNavId: options.mainNavId
    };
  }
  return $.extend(true, {}, internals._config);
};

var LaunchModel, _launchModel;

LaunchModel = (function() {
  LaunchModel.prototype.getBrandBarNode = function() {
    var bar;
    bar = $('brand-bar');
    if (bar.length < 1) {
      bar = $('<brand-bar></brand-bar>');
      bar.after($('account-switcher'));
    }
    bar.attr('params', '{ branding: branding, support: support, userName: userName, searchUrl: searchUrl, localLogout: localLogout, }');
    return bar;
  };

  LaunchModel.prototype.getHeaderBrandingNodes = function() {
    var appleIcon, favicon, head, nodes, stylesheet, tileColor, tileImage;
    nodes = [];
    head = $('head');
    stylesheet = $('#accountStylesheet');
    if (stylesheet.length < 1) {
      stylesheet = $('<link id="accountStylesheet" data-bind="href: cssUrl" type="text/css" rel="stylesheet" />');
      head.append(stylesheet);
    }
    nodes.push(stylesheet);
    favicon = $('#accountFavicon');
    if (favicon.length < 1) {
      favicon = $('<link id="accountFavicon" rel="icon" type="image/ico" data-bind="href: favIconUrl" />');
      head.append(favicon);
    }
    nodes.push(favicon);
    appleIcon = $('#accountAppleIcon');
    if (appleIcon.length < 1) {
      appleIcon = $('<link id="accountAppleIcon" rel="apple-touch-icon" data-bind="href: mobileIconUrl" />');
      head.append(appleIcon);
    }
    nodes.push(appleIcon);
    tileColor = $('#accountTileColor');
    if (tileColor.length < 1) {
      tileColor = $('<meta id="accountTileColor" name="msapplication-TileColor" data-bind="attr: {content: headerBackgroundColor}">');
      head.append(tileColor);
    }
    nodes.push(tileColor);
    tileImage = $('#accountTileImage');
    if (tileImage.length < 1) {
      tileImage = $('<meta id="accountTileImage" name="msapplication-TileImage" data-bind="attr: {content: mobileIconUrl}">');
      head.append(tileImage);
    }
    nodes.push(tileImage);
    return nodes;
  };

  LaunchModel.prototype.getAccountSwitcherNode = function() {
    var accountSwitcherNode;
    accountSwitcherNode = $('account-switcher');
    if (accountSwitcherNode.length < 1) {
      accountSwitcherNode = $('<account-switcher></account-switcher>');
      $('body').prepend(accountSwitcherNode);
    }
    accountSwitcherNode.attr('params', '{ accounts: accounts, loading: loadingAccounts, currentAccountAlias: currentAccountAlias }');
    return accountSwitcherNode;
  };

  LaunchModel.prototype.getMainNavNode = function() {
    var nav;
    nav = $('main-nav');
    if (nav.length < 1) {
      nav = $('<main-bar></main-bar>');
      nav.after($('brand-bar'));
    }
    nav.attr('params', '{ menus: menus, loading: loadingMenus, error: failedLoadingMenus, selectedItemId: selectedItemId }');
    return nav;
  };

  function LaunchModel(options) {
    var config;
    options = $.extend({}, options);
    config = internals.getConfig();
    this.localLogout = options.localLogout;
    this.accountSwitcherModel = new AccountSwitcherViewModel();
    this.accountSwitcherModel.currentAccountAlias(config.rootAccountAlias);
    ko.applyBindings(this.accountSwitcherModel, this.getAccountSwitcherNode()[0]);
    this.exposedCurrentAccountAlias = ko.observable(config.rootAccountAlias);
    this.exposedCurrentAccountAlias.subscribe((function(_this) {
      return function(newAlias) {
        return _this.accountSwitcherModel.currentAccountAlias(newAlias);
      };
    })(this));
    this.brandingModel = new BrandingModel();
    this.getHeaderBrandingNodes().forEach((function(_this) {
      return function(n) {
        return ko.applyBindings(_this.brandingModel, n[0]);
      };
    })(this));
    this.supportModel = new SupportModel();
    this.searchUrl = ko.observable();
    this.mainNavModel = new MainNavViewModel();
    this.mainNavModel.selectedItemId = options.mainNavId;
    ko.applyBindings(this.mainNavModel, this.getMainNavNode()[0]);
    this.accountSwitcherModel.currentAccountAlias.subscribe((function(_this) {
      return function(newAlias) {
        _this.mainNavModel.loadingMenus(true);
        _this.mainNavModel.menus([]);
        atlas.ajax({
          type: 'get',
          url: config.controlBaseUrl + "/api/navigation?accountAlias=" + newAlias,
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true
        }).done(function(menus) {
          _this.mainNavModel.loadingMenus(false);
          _this.mainNavModel.menus(menus.items);
        }).failed(function() {
          _this.mainNavModel.loadingMenus(false);
          return _this.mainNavModel.failedLoadingMenus(true);
        });
        return atlas.ajax({
          type: 'POST',
          url: config.controlBaseUrl + "/api/accountContext?switchToAccountId=" + newAlias,
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true
        }).done(function(context) {
          _this.brandingModel.update(context.branding);
          _this.supportModel.update(context.support);
          _this.searchUrl(_this.brandingModel.controlUrl() + context.searchUrl);
          _this.exposedCurrentAccountAlias(newAlias);
        });
      };
    })(this));
  }

  LaunchModel.prototype.launch = function() {
    var config, fetchAccountContextFromCookie, fetchAccountHierarchy, resultDeferred;
    resultDeferred = $.Deferred();
    config = internals.getConfig();
    fetchAccountHierarchy = atlas.ajax({
      bearerToken: config.bearerToken,
      url: config.apiBaseUrl + "/ui/switcher/accounthierarchy/" + config.rootAccountAlias
    }).done((function(_this) {
      return function(accounts) {
        _this.accountSwitcherModel.accounts([accounts]);
      };
    })(this));
    fetchAccountContextFromCookie = atlas.ajax({
      type: 'get',
      url: config.controlBaseUrl + "/api/accountContext",
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    }).done((function(_this) {
      return function(context) {
        _this.accountSwitcherModel.currentAccountAlias(context.currentAccountId);
        _this.exposedCurrentAccountAlias(_this.accountSwitcherModel.currentAccountAlias());
        _this.brandingModel.update(context.branding);
        _this.supportModel.update(context.support);
        _this.searchUrl(_this.brandingModel.controlUrl() + context.searchUrl);
        ko.applyBindings({
          branding: _this.brandingModel,
          support: _this.supportModel,
          userName: config.userName,
          searchUrl: _this.searchUrl,
          localLogout: _this.localLogout
        }, _this.getBrandBarNode()[0]);
      };
    })(this));
    $.when(fetchAccountHierarchy, fetchAccountContextFromCookie).done((function(_this) {
      return function() {
        _this.accountSwitcherModel.loadingAccounts(false);
        return resultDeferred.resolve({
          accounts: _this.accountSwitcherModel.accounts,
          currentAccountAlias: _this.exposedCurrentAccountAlias,
          branding: _this.brandingModel,
          support: _this.supportModel
        });
      };
    })(this));
    atlas.ajax({
      type: 'get',
      url: config.controlBaseUrl + "/api/navigation",
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    }).done((function(_this) {
      return function(menus) {
        _this.mainNavModel.loadingMenus(false);
        _this.mainNavModel.menus(menus.items);
      };
    })(this)).failed((function(_this) {
      return function() {
        _this.mainNavModel.loadingMenus(false);
        return _this.mainNavModel.failedLoadingMenus(true);
      };
    })(this));
    return resultDeferred;
  };

  return LaunchModel;

})();

_launchModel = null;

atlas.launch = function(options) {
  options = $.extend({}, options);
  if (_launchModel) {
    throw 'launch has already been called.';
  }
  _launchModel = new LaunchModel(options);
  return _launchModel.launch();
};

var MainNavViewModel;

MainNavViewModel = (function() {
  function MainNavViewModel() {
    this.loadingMenus = ko.observable(true);
    this.failedLoadingMenus = ko.observable(false);
    this.menus = ko.observableArray([]);
    this.selectedItemId = ko.observable('');
  }

  return MainNavViewModel;

})();

var ShellModel,
  bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

ShellModel = (function() {
  ShellModel.prototype.getAccountSwitcherNode = function() {
    var accountSwitcherNode;
    accountSwitcherNode = $('account-switcher');
    if (accountSwitcherNode.length < 1) {
      accountSwitcherNode = $('<account-switcher></account-switcher>');
      $('body').prepend(accountSwitcherNode);
    }
    accountSwitcherNode.attr('params', '{ accounts: accounts, loading: loadingAccounts, currentAccountAlias: currentAccountAlias }');
    return accountSwitcherNode;
  };

  function ShellModel(options) {
    this.getAccountSwitcherNode = bind(this.getAccountSwitcherNode, this);
    var fetchAccountHierarchy, getAccountContextFromCookie;
    options = $.extend({}, options);
    this.accountSwitcherModel = new AccountSwitcherViewModel();
    this.accountSwitcherModel.currentAccountAlias(options.rootAccountAlias);
    ko.applyBindings(this.accountSwitcherModel, this.getAccountSwitcherNode()[0]);
    fetchAccountHierarchy = atlas.ajax({
      bearerToken: options.bearerToken,
      url: "https://api.ctl.io/ui/switcher/accounthierarchy/" + options.rootAccountAlias
    });
    getAccountContextFromCookie = atlas.ajax({
      type: 'get',
      url: 'https://control.ctl.io/api/accountContext',
      xhrFields: {
        withCredentials: true
      },
      crossDomain: true
    }).done((function(_this) {
      return function(context) {
        _this.accountSwitcherModel.currentAccountAlias(context.currentAccountId);
      };
    })(this));
    $.when(fetchAccountHierarchy, getAccountContextFromCookie).done((function(_this) {
      return function(accounts) {
        _this.accountSwitcherModel.accounts([accounts[0]]);
        _this.accountSwitcherModel.loadingAccounts(false);
      };
    })(this));
    this.accountSwitcherModel.currentAccountAlias.subscribe((function(_this) {
      return function(newAlias) {
        return atlas.ajax({
          type: 'POST',
          url: "https://control.ctl.io/api/accountContext?switchToAccountId=" + newAlias,
          xhrFields: {
            withCredentials: true
          },
          crossDomain: true
        }).done(function() {});
      };
    })(this));
  }

  return ShellModel;

})();

  }));
}());


$.holdReady(true);
$.get("https://assets.ctl.io/atlas/1.0.0/templates/atlas.tmpl.min.html", function(tmpl) {
  $("head")
    .append(tmpl);
  $.holdReady(false);
});

//# sourceMappingURL=atlas.js.map
